import { render, staticRenderFns } from "./ScrollWallDefault.vue?vue&type=template&id=228ff5ea&scoped=true"
import script from "./ScrollWallDefault.vue?vue&type=script&lang=js"
export * from "./ScrollWallDefault.vue?vue&type=script&lang=js"
import style0 from "./ScrollWallDefault.vue?vue&type=style&index=0&id=228ff5ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228ff5ea",
  null
  
)

export default component.exports